import React, { Component } from 'react';

class AiModelResultChartContainer extends Component<Props> {
  render() {
    const { title, children } = this.props;
    return (
      <div style={{ boxShadow: '2px 2px 15px 0px #0000000D' }} className='bg-white border border-f-gray-3 rounded-[8px] h-[500px] gap-2 p-2'>
        <h3 className='text-sm text-f-black-2 font-semibold border-b border-b-f-gray-3 p-2'>{title}</h3>
        <div className='h-[calc(100%-60px)]'>{children}</div>
      </div>
    );
  }
}

interface Props {
  title: string;
  children: React.ReactNode;
}

export default AiModelResultChartContainer;
